<!-- eslint-disable max-len -->
<template>
  <div class="c-phone-verify">
    <c-go-back :backroute="backroute" @click="closeCode" />
    <div v-show="show" class="register-form">
      <div class="logo">
        <img :src="logo">
      </div>
      <n-loader :loading="$var('load')" />
        <h1>Подтверждение!</h1>
        <p>Введите 6-и значный код, отправленный на электронную почту</p>

      <c-email-code-input :received="code" :code.sync="code" />

      <template v-if="isInputError">
        <p class="error-tries">
          {{ translateForTries('lock', countTries, formattedTimerForInputBlocked) }}
        </p>
      </template>

      <div class="button-place">
        <n-button type="submit" class="base-blue-button" :disabled="isBlockedButton" @click="close()"><t name="1.4.5" /></n-button>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '/src/assets/logo.png'

export default {
  name: 'CEmailVerify',
  props: {
    backroute: {
      type: String,
      default: 'mobile.profile.security',
    },
    email: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    documentId: {
      type: Number,
      required: false,
    },
    isPermanentOtp: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      code: '',
      isDisabled: true,
      show: true,
      timer: 0,
      interval: null,
      logo,
      timerEnded: false,
      dangerMessage: '',
      resendDelays: [ 30, 60, 120, 300, 1800 ],
      currentDelayIndex: 0,

      // Блокировки при неверном вводе смс кода
      countTries: 0,
      lastErrorCount: 0,
      lockUntil: null,
      lockDurations: {
        5: 60,
        10: 120, 
        15: 300, 
        20: 600, 
        30: 1800, 
      },
      timerEndedForInputBlocked: false,
      timerForInputBlocked: 60,
      intervalForInputBlocked: null,
      currentIntervalIndexForInputBlocked: 0,
      isInputError: false, 

    }
  },
  computed: {
    // Блокировки при неверном вводе смс кода
    isBlockedButton() {
      return this.isDisabled || this.lockUntil;
    },
    formattedTimerForInputBlocked() {
      const minutes = Math.floor(this.timerForInputBlocked / 60);
      const seconds = this.timerForInputBlocked % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
  },
  watch: {
    code() {
      if (this.code.length === 6) {
        this.isDisabled = false
      }
    },
  },
  beforeDestroy() {
    this.removeListener()
  },
  created() {
    if (this.email === undefined) {
      this.$router.push({ name: 'login', })
    } else if (!this.isPermanentOtp) {
      this.sendCode()
    }
  },
  mounted() {
    //this.startTimer()
  },
  methods: {
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `0${minutes}:${secs.toString().padStart(2, '0')}`;
    },
    setCode() {
      document.addEventListener('onSMSArrive', (args) => {
        this.code = args.message.substr(0, 6)
      })
    },
    removeListener() {
      document.removeEventListener('onSMSArrive', (args) => {})
    },
    listenSms() {
      this.setCode()
      cordova.plugins.SMSRetriever.startWatch((r) => {}, (e) => {})
    },
    closeCode() {
      this.$emit('update:show', false)
    },
    startTimer() {
      this.timerEnded = false;
      let timerValue = this.timer;
      const timerElement = this.$refs.timerDisplay.querySelector('#timer');

      this.interval = setInterval(() => {
        if (timerValue > 0) {
          timerValue--;
          timerElement.textContent = this.formatTime(timerValue);
        } else {
          clearInterval(this.interval);
          this.timerEnded = true;
        }
      }, 1000);
    },
    resetTimer() {
      clearInterval(this.interval);
      const nextDelay = this.resendDelays[Math.min(this.currentDelayIndex, this.resendDelays.length - 1)];
      this.timer = nextDelay;
      if (this.currentDelayIndex < this.resendDelays.length - 1) {
        this.currentDelayIndex++;
      }
      this.startTimer();
    },
    sendCode() {
      this.$var('load', true)
      const data = {
        email: this.email,
      }
      

      $api.auth.sendEmailCode(this.email).then((response) => {
        //this.resetTimer();
      }).catch(() => {
        this.$emit('update:show', false)
      }).finally(() => {
        this.$var('load', false)
      })


    },
    close() {
      if (this.code.length === 6) {
        this.$var('load', true)
        this.$emit('updateData', this.code)
        if (this.isPermanentOtp) {
          $api.auth.checkPermanentCodeOtp(this.documentId, { code: this.code }).then((response) => {
            if (response.data.content.isAvailable) {
              this.countTries = 0;
              this.$emit('update:state', true)
              this.closeForm()
            } else {
              this.$emit('update:state', false)
              this.handleCountTriesMessage()
            }
          }).catch((response) => {
            this.dangerMessage = $app.secure.clean($n.t(response.response.data.message))
          }).finally(() => {
            this.$var('load', false)
          })
        } else {
          $api.auth.checkEmailCode(this.email, { code: this.code, }).then((response) => {
            if (response.data.content.isAvailable) {
              this.countTries = 0;
              this.$emit('update:state', true)
              this.closeForm()
            } else {
              this.$emit('update:state', false)
              this.handleCountTriesMessage()
            }
          }).catch((response) => {
            this.dangerMessage = $app.secure.clean($n.t(response.response.data.message))
          }).finally(() => {
            this.$var('load', false)
          })
        }

      }
    },
    closeForm() {
      this.$emit('update:show', false)
    },

    // Блокировки при неверном вводе смс кода
    startTimerForInputBlocked() {
      this.timerEndedForInputBlocked = false;
      this.clearTimerForInputBlocked();

      this.intervalForInputBlocked = setInterval(() => {
        if (this.timerForInputBlocked > 0) {
          this.timerForInputBlocked--;
        } else {
          this.clearTimerForInputBlocked();
          this.timerEndedForInputBlocked = true;
          this.lockUntil = false;
          this.isInputError = false; 
        }
      }, 1000);
    },

    clearTimerForInputBlocked() {
      if (this.intervalForInputBlocked) {
        clearInterval(this.intervalForInputBlocked);
        this.intervalForInputBlocked = null;
      }
    },

    handleCountTriesMessage() {
      this.countTries += 1;
      this.setRemainingAttemptsMessage();

      if (this.lockDurations[this.countTries]) {
        this.applyInputLock();
      }
    },

    setRemainingAttemptsMessage() {
      const keysLockDurations = Object.keys(this.lockDurations).map(Number).sort((a, b) => a - b);
      const attempts = keysLockDurations.find((attempts) => attempts > this.countTries) || null;
      const remainingAttempts = attempts - this.countTries
      this.dangerMessage = this.translateForTries('attempts', remainingAttempts)
    },

    applyInputLock() {
      this.timerForInputBlocked = this.lockDurations[this.countTries];
      this.lockUntil = true;
      this.isInputError = true; 
      this.startTimerForInputBlocked();
      this.dangerMessage = null;
      this.lastErrorCount = this.countTries;
      delete this.lockDurations[this.countTries];
    },

    translateForTries(type, remainingAttempts, time = null) {
      const locale = localStorage.getItem('locale');

      if (type === 'attempts') {
        switch (locale) {
        case 'ru':
          return `Неправильно введен код, осталось попыток ${remainingAttempts}.`
        case 'kz':
          return `Қате код енгізілді, ${remainingAttempts} әрекет қалды.`
        default:
          return `Неправильно введен код, осталось попыток ${remainingAttempts}.`
        }
      }

      if (type === 'lock') {
        switch (locale) {
        case 'ru': 
          return `Неправильно введен код ${remainingAttempts} раз. Попробуйте через ${time}.`;
        case 'kz': 
          return `${remainingAttempts} рет қате код енгізілді, ${time} кейін әрекетті қайталаңыз.`;
        default: 
          return `Неправильно введен код ${remainingAttempts} раз. Попробуйте через ${time}.`;
        }
      }
    },

  },
}
</script>

<style lang="scss" scoped>
.c-phone-verify {
  z-index: 11;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: #F9F9F9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  ::v-deep{
    .c-go-back{
      position: absolute;
      top: calc(20px + env(safe-area-inset-top));
      left: 25px;
    }
  }

  .content {
    .text {
      h1 {
        font-size: 24px;
        color: #1c1c1c;
        font-weight: 500;
        text-align: center;
        margin: 0 0 5px 0;
      }
      p {
        margin: 0 auto 30px;
        text-align: center;
        width: 80%;
      }
    }
    .lower-text {
      p {
        margin: 0;
        font-size: 14px;
        text-align: center;
        color: #A91CD2;
        text-decoration: underline;
        padding: 10px 0;

        &:first-child {
          font-size: 12px;
          color: #9CA3AF;
          text-decoration: none;
          padding: 0;
          &.danger {
            color: red;
            font-size: 16px;
          }
        }
      }
    }
    .button-place {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 30px;
      margin-bottom: 30px;
      .user-default-button {
        width: 90%;
        display: block;
        margin: 0 auto;
      }
    }
  }
}

.error-tries {
  color: red;
  text-align: center;
}

.register-form {
  .logo {
    height: 92px;
    width: 140px;
    margin: 0 auto 18px;

    img {
      max-width: 100%;
      height: 100%;
    }
  }

  text-align: center;
  padding: 18px;
  border-radius: 5px;
  background: #fff;
  border: 1px solid rgba(31, 95, 191, 0.16);
  box-shadow: 0 34px 80px rgba(14, 63, 150, 0.18), 0 12px 26px rgba(31, 95, 191, 0.1), 0 1px 0 rgba(255, 255, 255, 0.95) inset;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background:
        radial-gradient(560px 240px at 0% 0%, rgba(31, 95, 191, .14), transparent 60%),
        radial-gradient(520px 240px at 100% 8%, rgba(199, 225, 43, .14), transparent 62%),
        linear-gradient(180deg, rgba(255,255,255,.85), rgba(255,255,255,0));
    z-index: 0;
  }
  .base-input {
    margin-bottom: 14px;

    ::v-deep {
      .n-content {
        height: 52px;
        border-radius: 5px;

        border: 1px solid rgba(31, 95, 191, .22);

        box-shadow: 0 16px 32px rgba(14, 63, 150, .12),
        0 4px 0 rgba(255, 255, 255, .95) inset,
        0 -1px 0 rgba(14, 63, 150, .06) inset;

        padding: 14px 14px;
        transition: transform .12s ease, box-shadow .18s ease, border-color .18s ease;
      }

      .n-content:hover {
        border-color: rgba(31, 95, 191, .34);
        box-shadow: 0 20px 40px rgba(14, 63, 150, .14),
        0 0 0 3px rgba(31, 95, 191, .10),
        0 4px 0 rgba(255, 255, 255, .95) inset,
        0 -1px 0 rgba(14, 63, 150, .06) inset;
        transform: translateY(-1px);
      }
    }
  }

  .base-white-button {
    margin: 8px auto 0;
    width: 92%;

    padding: 12px 14px;
    border-radius: 14px;

    background: linear-gradient(180deg, rgba(255, 255, 255, .95), rgba(255, 255, 255, .72));
    border: 1px solid rgba(31, 95, 191, .16);

    box-shadow: 0 16px 34px rgba(14, 63, 150, .12),
    0 1px 0 rgba(255, 255, 255, .9) inset;

    color: rgba(15, 23, 42, .82);
    font-weight: 900;
    text-align: center;
    cursor: pointer;

    transition: transform .12s ease, box-shadow .18s ease;

    &:hover {
      background: linear-gradient(135deg, #fcfcfd 0%, #fcfcfd 100%);
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(31, 95, 191, 0.45);
    }
  }
  .base-blue-button {
    width: 92%;
    margin: 10px auto 18px;
    display: block;

    height: 52px;
    border-radius: 5px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    color: #FFFFFF;
    background: linear-gradient(135deg, #1f5fbf 0%, #0f3f96 100%);
    border: none;

    box-shadow: 0 4px 12px rgba(31, 95, 191, 0.3);
    transition: all 0.25s ease;

    &:hover {
      background: linear-gradient(135deg, #0f3f96 0%, #1f5fbf 100%);
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(31, 95, 191, 0.45);
    }

    &:active {
      transform: translateY(0);
      filter: brightness(0.95);
    }

    &.gray {
      color: #0f3f96;
      background: linear-gradient(135deg, #e5eaf8 0%, #cfd9f5 100%);
      box-shadow: 0 4px 12px rgba(14, 63, 150, 0.2);

      &:hover {
        background: linear-gradient(135deg, #cfd9f5 0%, #e5eaf8 100%);
        box-shadow: 0 6px 16px rgba(14, 63, 150, 0.35);
      }
    }
  }

  > * { position: relative; z-index: 1; }

  .register-input {
    margin-bottom: 12px;

    ::v-deep {
      .n-content {
        height: 52px;
        border-radius: 14px;

        background: linear-gradient(180deg, #ffffff, #f6f7fb);
        border: 1px solid rgba(31, 95, 191, .22);

        box-shadow:
            0 16px 32px rgba(14, 63, 150, .12),
            0 4px 0 rgba(255,255,255,.95) inset,
            0 -1px 0 rgba(14, 63, 150, .06) inset;

        padding: 14px;
        transition: transform .12s ease, box-shadow .18s ease, border-color .18s ease;
      }

      .n-content:hover {
        border-color: rgba(31, 95, 191, .34);
        box-shadow:
            0 20px 40px rgba(14, 63, 150, .14),
            0 0 0 3px rgba(31, 95, 191, .10),
            0 4px 0 rgba(255,255,255,.95) inset,
            0 -1px 0 rgba(14, 63, 150, .06) inset;
        transform: translateY(-1px);
      }

      input:focus { outline: none; }
    }
  }
}

</style>
